import { Entity } from '@backstage/catalog-model';

export function isKosliAvailable(entity: Entity) {
    const hasAnnotation = !!entity.metadata.annotations?.['kosli.io/artifact-name']
    // For now we allow entities based on name.
    return hasAnnotation;
}
